import {
  EventDispatcher,
  DBxEvent
} from "cartovista";
import ResultItem from "cartovistaExtend/panels/Results/ResultItem";
import "styles/ResultsList.css";﻿

    export default class ResultsList extends EventDispatcher {
      constructor($container, layer, dataTable, accordion) {
        super();
        this._accordion = accordion ? accordion : false;
        this._$container = $container;
        var resultsListAccordionHtml = this._accordion ? '<div class="accordion ResultsList_accordion"></div>' : '<ul class="list-group ResultsList_accordion"></ul>';
        this._$container.html(resultsListAccordionHtml);
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        this._dataViewController = window.cartovista.getUIController(this._map).findInstance("dataView-selectedFeatures");
        this.resultItems = [];
        this.increment = 0;
        this.layer = layer;
        this.dataTable = dataTable;
        Object.defineProperties(this, {
            "count": {
                get: function() { return this.resultItems.length; }
            }
        });
      }

    addResult(features, name) {
        this.increment += 1;
        this.resultItems.push(new ResultItem(this, features, name));
        this.generateUI();
        this.dispatchEvent(new DBxEvent("ResultsList_resultAdded"));
    };

    removeResult(resultItem) {
        _.remove(this.resultItems, resultItem);
        this.layer.removeFeatures(_.map(resultItem.featuresItems, "feature"));
        this.dataTable.removeDataRows(_.map(resultItem.featuresItems, "feature.id"));
        this.generateUI();
        this.dispatchEvent(new DBxEvent("ResultsList_resultRemoved"));
    };

    generateUI() {
        this._$container.find(".ResultsList_accordion").html(_.reverse(_.invokeMap(this.resultItems, "_generateResultItemUI", this._$container.attr('id'))));
    };

    zoomOnFeatures(features) {
        this._mapController.zoomOnFeatures(features, (features.length > 1 ? null : this.layer), null, false);
    };

    toggleFeatureDataView(features) {
        if(this._dataViewController.isActive){
            this._dataViewController.selectedInteractiveLayer.computeSelectionStack(function(linkingIds){
                if (_.isEqual(linkingIds, _.map(features, "id"))) {
                    this.layer.clearSelection();
                    this._dataViewController.deactivate();
                } else{
                    this._dataViewController.selectedInteractiveLayer = this.layer;
                    this.layer.selectFeatures(_.map(features, "id"), false);
                    this._dataViewController.activate();
                }
            }.bind(this));
        } else{
            this._dataViewController.selectedInteractiveLayer = this.layer;
            this.layer.selectFeatures(_.map(features, "id"), false);
            this._dataViewController.activate();
        }

    };

}
